module.exports = __webpack_public_path__ + "static/airportDefault.586a193c.png";